import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC7Gym-TH76mJUqu7rxzo0N1rkEEmA8WF0",
  authDomain: "clone-react-8ecea.firebaseapp.com",
  projectId: "clone-react-8ecea",
  storageBucket: "clone-react-8ecea.appspot.com",
  messagingSenderId: "969880203142",
  appId: "1:969880203142:web:d40d50c5c7724991668607",
  measurementId: "G-9DL4ZJLEF3",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const firestoreDB = firebaseApp.firestore();
const auth = firebase.auth();

export { firestoreDB, auth };
